import React from 'react'
import './style.css'
import Loader from '../../Loader/Loader'

export default function LoaderDocs({showModal, erros, setShowModal}) {

        return (
            <div id="myModal" style={{display: showModal ? 'block' : 'none'}} className="modal">
                <div className="modal-content">
                    {
                        erros ? 
                            <>
                                <p className='txt-alert'>{erros}</p>
                                <div className="btn-area">
                                    <button className='okbtn' onClick={()=> {
                                        setShowModal(false)
                                    }}>Fermer</button>
                                </div>
                            </>
                        : 
                        <>
                            <h4 style={{textAlign:'center'}}>Votre document est en cours de signature</h4>
                            <Loader />
                        </>
                    }
                </div>
            </div>
        )
}
